import { themeColors } from "../components/chartTheme";

/**
 * Returns the zone color for a BMI value.
 * <16 = RED, 16-24.9 = GREEN, 25-29.9 = AMBER, >=30 = RED
 */
export const getBmiColor = (bmi: number): string => {
  if (bmi < 16) {
    return themeColors.error;
  }
  if (bmi < 25) {
    return themeColors.success;
  }
  if (bmi < 30) {
    return themeColors.warning;
  }
  return themeColors.error;
};

/**
 * Formats a BMI value for display: integers stay as-is, decimals show 2 places.
 */
export function formatBmiDisplay(bmi: number): string {
  if (bmi % 1 === 0) {
    return String(Math.round(bmi));
  }
  return bmi.toFixed(2);
}

export const ZONE_LABELS: {
  yMin: number;
  yMax: number;
  labelKey:
    | "HealthChart.healthHistoryChart.zone.underweight"
    | "HealthChart.healthHistoryChart.zone.healthyWeight"
    | "HealthChart.healthHistoryChart.zone.overweight"
    | "HealthChart.healthHistoryChart.zone.obesity";
}[] = [
  {
    yMin: 15,
    yMax: 20,
    labelKey: "HealthChart.healthHistoryChart.zone.underweight",
  },
  {
    yMin: 21,
    yMax: 26,
    labelKey: "HealthChart.healthHistoryChart.zone.healthyWeight",
  },
  {
    yMin: 27,
    yMax: 32,
    labelKey: "HealthChart.healthHistoryChart.zone.overweight",
  },
  {
    yMin: 33,
    yMax: 38,
    labelKey: "HealthChart.healthHistoryChart.zone.obesity",
  },
];

/**
 * Returns the display color for a BMI zone label.
 */
export function getZoneLabelColor(
  labelKey: (typeof ZONE_LABELS)[number]["labelKey"]
): string {
  if (
    labelKey === "HealthChart.healthHistoryChart.zone.underweight" ||
    labelKey === "HealthChart.healthHistoryChart.zone.obesity"
  ) {
    return themeColors.error;
  }
  if (labelKey === "HealthChart.healthHistoryChart.zone.healthyWeight") {
    return themeColors.success;
  }
  return themeColors.warning;
}
